module.exports = __webpack_public_path__ + "static/media/heart_half.0ebbc1c8.svg";